<template>
    <Projects v-if="!project" @setProject="setProject" :projects="projects" :districtProjects="districtProjects" />
    <ProjectDialog v-if="project" :project="project" :newProject="newProject" :projects="projects" />
</template>

<script>
import ProjectDialog from '@/components/project module/ProjectDialog.vue';
import Projects from '@/components/project module/Projects.vue';
import { ref, reactive } from 'vue';

export default {
    name: 'NewProjectView',
    components: {
        Projects,
        ProjectDialog,
    },
    data() {
        return {
            project: null,
            newProject: true,
            projects: [],
            districtProjects: []
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.currentUser;
        },
        isAdmin() {
            return this.$store.getters.currentUser?.userType == "admin";
        },
    },
    methods: {
        setProject(project) {
            console.log(project);
            if (!project) {
                this.project = {
                    projectTitle: '',
                    proponent: '',
                    agreement: '',
                    mainContractor: '',
                    commencementDate: null,
                    engineerConsultant: '',
                    completionDate: null,
                    bufferRadius: 300,
                    description: '',
                    specialFeature: '',
                    targetDistrict: '',
                    tasks: reactive([]),
                    zones: reactive([]),
                    equipments: reactive([]),
                    unregisteredNeighbours: reactive([]),
                    hasNeighbors: false,
                }
                this.$store.dispatch('setCurrentProject', { project: this.project });
                this.newProject = true;
            }
            else {
                this.project = project;
                this.newProject = false;
            }
        },
        getProjects(userId, successCallback) {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}project?userId=${userId}`)
                .then(response => {
                    successCallback(response.data);
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 401) {
                        localStorage.removeItem("epd-cnmp-user")
                        props.$router.replace({ path: '/Login' });
                    }
                })
        },
        getDistrictProjects(district, successCallback) {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}project?district=${district}`)
                .then(response => {
                    successCallback(response.data);
                })
                .catch(error => {
                    console.log(error);
                })
        },
    },
    mounted() {
        let props = this;
        let user = props.$store.getters.currentUser;
        props.getProjects(user.id, function (projectsRaw) {
            projectsRaw.forEach(p => {
                p.projectTitleWithoutVersion = p.projectTitle.split("@")[0]
                p.opening = "pi pi-folder-open";
                p.openingReadonly = "pi pi-eye";
                p.deleting = "pi pi-trash";
                let filtered = props.projects.filter(p1 => p1.projectTitleWithoutVersion === p.projectTitleWithoutVersion)
                if (filtered.length > 0) {
                    filtered[0].versions.push({
                        project: p,
                        version: p.projectTitle.split("@").length > 1 ? p.projectTitle.split("@")[1] : "-"
                    })

                }
                else {
                    let version = {
                        project: p,
                        version: p.projectTitle.split("@").length > 1 ? p.projectTitle.split("@")[1] : "-"
                    }
                    props.projects.push({
                        projectTitleWithoutVersion: p.projectTitleWithoutVersion,
                        versions: [version],
                        selectedVersion: version,
                        modifiedAt: p.modifiedAt
                    })
                }
            });
            console.log(props.projects)
            props.$store.dispatch('setUserProjects', {
                projects: props.projects
            });
            if (user.userType == "epd" || props.isAdmin) {
                props.getDistrictProjects(props.isAdmin ? "all" : user.district.replace(/&/g, "%26"), function (districtProjectsRaw) {
                    districtProjectsRaw.forEach(p => {
                        p.projectTitleWithoutVersion = p.projectTitle.split("@")[0]
                        p.opening = "pi pi-folder-open";
                        p.deleting = "pi pi-trash";
                        let filtered = props.districtProjects.filter(p1 => p1.projectTitleWithoutVersion === p.projectTitleWithoutVersion)
                        if (filtered.length > 0) {
                            filtered[0].versions.push({
                                project: p,
                                version: p.projectTitle.split("@").length > 1 ? p.projectTitle.split("@")[1] : "-"
                            })

                        }
                        else {
                            let version = {
                                project: p,
                                version: p.projectTitle.split("@").length > 1 ? p.projectTitle.split("@")[1] : "-"
                            }
                            props.districtProjects.push({
                                projectTitleWithoutVersion: p.projectTitleWithoutVersion,
                                versions: [version],
                                selectedVersion: version,
                                modifiedAt: p.modifiedAt
                            })
                        }
                    });
                    console.log(props.districtProjects)
                    props.$store.dispatch('setDistrictProjects', {
                        districtProjects: props.districtProjects
                    });
                })
            }
        })
    }
}
</script>

<style></style>